import { AnyAction } from "redux";
import * as actionTypes from "./actionTypes";

export const getTeamRanking = (): AnyAction => ({
  type: actionTypes.TEAM_RANKING_GET_TEAM_RANKING,
});
